module.exports = __webpack_public_path__ + "static/media/sportsman xp 1000 s.8b238d41.glb";